(function(){
  'use strict';
  var YG = window.YG || {};
  var routes = YG.routes || {};

  /* ---------- money ---------- */
  function formatMoney(cents, format){
    if (typeof cents === 'string') cents = cents.replace('.','');
    var f = format || YG.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal){
      precision = (precision==null)?2:precision; thousands = thousands||','; decimal = decimal||'.';
      if (isNaN(number)||number==null) return 0;
      number = (number/100).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1'+thousands),
          cent = parts[1] ? decimal+parts[1] : '';
      return dollars+cent;
    }
    var value='', match = f.match(placeholder);
    var key = match ? match[1] : 'amount';
    switch(key){
      case 'amount': value=fmt(cents,2); break;
      case 'amount_no_decimals': value=fmt(cents,0); break;
      case 'amount_with_comma_separator': value=fmt(cents,2,'.',','); break;
      case 'amount_no_decimals_with_comma_separator': value=fmt(cents,0,'.',','); break;
      case 'amount_with_space_separator': value=fmt(cents,2,' ',','); break;
      case 'amount_no_decimals_with_space_separator': value=fmt(cents,0,' ',''); break;
      default: value=fmt(cents,2);
    }
    return f.replace(placeholder, value);
  }

  /* ---------- ticker seamless loop ---------- */
  var ticker = document.getElementById('ticker');
  if (ticker && ticker.children.length) ticker.innerHTML += ticker.innerHTML;

  /* ---------- header shrink + mobile cta ---------- */
  var header = document.getElementById('header');
  var mcta = document.getElementById('mcta');
  var footerEl = document.querySelector('.footer');
  window.addEventListener('scroll', function(){
    if(header){ header.classList.toggle('shrink', window.scrollY>40); }
    if(mcta && footerEl){ mcta.classList.toggle('hide', footerEl.getBoundingClientRect().top < window.innerHeight); }
  }, {passive:true});

  /* ---------- reveal ---------- */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:.12});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  /* ---------- wishlist (cosmetic) ---------- */
  document.addEventListener('click', function(e){
    var wl = e.target.closest('.wish');
    if(wl){ e.preventDefault(); wl.classList.toggle('active'); }
  });

  /* ---------- drawer + overlay ---------- */
  var overlay = document.getElementById('overlay');
  var drawer = document.getElementById('drawer');
  var mobileNav = document.getElementById('mobileNav');
  function lock(){ document.body.style.overflow='hidden'; }
  function unlock(){ document.body.style.overflow=''; }
  function openDrawer(){ if(!drawer) return; overlay.classList.add('open'); drawer.classList.add('open'); lock(); }
  function closeAll(){ if(overlay)overlay.classList.remove('open'); if(drawer)drawer.classList.remove('open'); if(mobileNav)mobileNav.classList.remove('open'); unlock(); }
  var cartBtn = document.getElementById('cartBtn');
  if(cartBtn) cartBtn.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); });
  var dc = document.getElementById('drawerClose'); if(dc) dc.addEventListener('click', closeAll);
  if(overlay) overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeAll(); });
  var burger = document.getElementById('burger');
  if(burger) burger.addEventListener('click', function(){ overlay.classList.add('open'); mobileNav.classList.add('open'); lock(); });
  var mclose = document.getElementById('mobileClose'); if(mclose) mclose.addEventListener('click', closeAll);
  if(mobileNav) mobileNav.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeAll); });

  /* ---------- cart rendering ---------- */
  function updateCount(count){
    var badge = document.getElementById('cartCount');
    if(!badge) return;
    badge.textContent = count;
    badge.classList.toggle('show', count>0);
  }
  function renderShipBar(total){
    var fill = document.getElementById('shipFill'); var msg = document.getElementById('shipMsg');
    if(!fill||!msg) return;
    var threshold = YG.freeShip||0;
    if(threshold<=0){ document.getElementById('shipBar').style.display='none'; return; }
    var remain = threshold-total;
    if(remain<=0){ fill.style.width='100%'; msg.innerHTML="You've unlocked <b>free shipping</b>! \uD83C\uDF89"; }
    else { fill.style.width=Math.min(100,(total/threshold)*100)+'%'; msg.innerHTML='Add <b>'+formatMoney(remain)+'</b> more to unlock <b>free shipping</b> \uD83D\uDE9A'; }
  }
  function renderCart(cart){
    updateCount(cart.item_count);
    renderShipBar(cart.total_price);
    var body = document.getElementById('cartBody');
    var foot = document.getElementById('cartFoot');
    var empty = document.getElementById('cartEmpty');
    if(!body) return;
    body.querySelectorAll('.litem').forEach(function(n){ n.remove(); });
    if(cart.item_count===0){
      if(empty) empty.style.display='block';
      if(foot) foot.style.display='none';
    } else {
      if(empty) empty.style.display='none';
      if(foot) foot.style.display='block';
      cart.items.forEach(function(i, idx){
        var line = idx+1;
        var img = i.image ? i.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_200x$1$2') : '';
        var opts = (i.variant_title && i.variant_title!=='Default Title') ? i.variant_title : '';
        var el = document.createElement('div'); el.className='litem';
        el.innerHTML =
          '<a href="'+i.url+'"><img src="'+img+'" alt="'+i.product_title+'"></a>'+
          '<div><h4>'+i.product_title+'</h4>'+(opts?'<div class="li-size">'+opts+'</div>':'')+
          '<div class="li-price">'+formatMoney(i.final_line_price)+'</div>'+
          '<div class="qty"><button data-line="'+line+'" data-q="'+(i.quantity-1)+'" aria-label="Decrease">\u2212</button><span>'+i.quantity+'</span><button data-line="'+line+'" data-q="'+(i.quantity+1)+'" aria-label="Increase">+</button></div>'+
          '</div>'+
          '<button class="li-remove" data-line="'+line+'" data-q="0">Remove</button>';
        body.appendChild(el);
      });
    }
    var sub = document.getElementById('subtotal'); if(sub) sub.textContent = formatMoney(cart.total_price);
    var tot = document.getElementById('total'); if(tot) tot.textContent = formatMoney(cart.total_price);
  }
  function fetchCart(){
    return fetch((routes.cart||'/cart')+'.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ renderCart(c); return c; });
  }
  function changeLine(line, qty){
    return fetch((routes.cartChange||'/cart/change')+'.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({line:line, quantity:qty})
    }).then(function(r){return r.json();}).then(renderCart);
  }
  function addVariant(id, qty){
    return fetch((routes.cartAdd||'/cart/add')+'.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:id, quantity:qty||1}]})
    }).then(function(r){ if(!r.ok) return r.json().then(function(e){ throw e; }); return r.json(); });
  }

  /* qty +/- and remove inside drawer */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-line]');
    if(b){ changeLine(parseInt(b.dataset.line,10), parseInt(b.dataset.q,10)); }
  });

  /* ---------- size selection (cards) ---------- */
  document.addEventListener('click', function(e){
    var s = e.target.closest('.card .size, .pdp .opt-btns .size');
    if(!s || s.hasAttribute('disabled')) return;
    var row = s.parentElement;
    row.querySelectorAll('.size').forEach(function(x){ x.classList.remove('sel'); });
    s.classList.add('sel');
    // pdp option change
    if(s.closest('.pdp')) window.__ygVariantChange && window.__ygVariantChange();
  });

  /* ---------- quick add ---------- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.quick-add');
    if(!btn || btn.tagName==='A') return;
    e.preventDefault();
    var card = btn.closest('.card');
    var id = btn.dataset.variantId;
    var sized = card && card.querySelector('.sizes .size');
    if(sized){
      var sel = card.querySelector('.sizes .size.sel');
      if(!sel){
        var first = card.querySelector('.sizes .size:not([disabled])');
        if(first) first.classList.add('sel');
        var label = btn.textContent; btn.textContent='Pick a size \u2191';
        setTimeout(function(){ btn.textContent=label; },1300);
        return;
      }
      id = sel.dataset.variantId;
    }
    if(!id) return;
    var orig = btn.textContent; btn.textContent='Adding\u2026';
    addVariant(id,1).then(function(){ return fetchCart(); }).then(function(){
      btn.textContent='Added \u2713'; openDrawer();
      setTimeout(function(){ btn.textContent=orig; },1200);
    }).catch(function(){ btn.textContent='Sold out'; setTimeout(function(){ btn.textContent=orig; },1400); });
  });

  /* ---------- PDP: variant selection ---------- */
  var pdp = document.querySelector('[data-product-json]');
  if(pdp){
    var variants = JSON.parse(pdp.textContent);
    var form = document.getElementById('pdpForm');
    var priceNow = document.querySelector('.pdp__price .now');
    var priceWas = document.querySelector('.pdp__price .was');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var addBtn = document.getElementById('pdpAdd');
    function currentOptions(){
      var opts=[];
      document.querySelectorAll('.pdp [data-opt-index]').forEach(function(group){
        var sel = group.querySelector('.size.sel');
        if(sel){ opts[parseInt(group.dataset.optIndex,10)] = sel.dataset.value; }
        else {
          var s = group.querySelector('select'); if(s) opts[parseInt(group.dataset.optIndex,10)] = s.value;
        }
      });
      return opts;
    }
    window.__ygVariantChange = function(){
      var opts = currentOptions();
      var match = variants.find(function(v){
        return v.options.every(function(o,i){ return String(o)===String(opts[i]); });
      });
      if(!match){ return; }
      if(idInput) idInput.value = match.id;
      if(priceNow) priceNow.textContent = formatMoney(match.price);
      if(match.compare_at_price && match.compare_at_price>match.price){
        if(priceWas){ priceWas.style.display='inline'; priceWas.textContent=formatMoney(match.compare_at_price); }
        if(priceNow) priceNow.classList.add('sale');
      } else {
        if(priceWas) priceWas.style.display='none';
        if(priceNow) priceNow.classList.remove('sale');
      }
      if(addBtn){
        if(match.available){ addBtn.disabled=false; addBtn.textContent='Add to bag'; }
        else { addBtn.disabled=true; addBtn.textContent='Sold out'; }
      }
    };
    document.querySelectorAll('.pdp select').forEach(function(s){ s.addEventListener('change', window.__ygVariantChange); });
    // pdp qty
    var qwrap = document.querySelector('.pdp__buy .qty');
    if(qwrap){
      qwrap.addEventListener('click', function(ev){
        var b = ev.target.closest('button'); if(!b) return;
        var span = qwrap.querySelector('span'); var val = parseInt(span.textContent,10);
        val = Math.max(1, val + (b.dataset.d==='1'?1:-1)); span.textContent=val;
        var qi = form.querySelector('[name="quantity"]'); if(qi) qi.value=val;
      });
    }
    // ajax add from pdp
    if(form){
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        var id = idInput ? idInput.value : null; if(!id) return;
        var q = 1; var qi = form.querySelector('[name="quantity"]'); if(qi) q=parseInt(qi.value,10)||1;
        var t = addBtn.textContent; addBtn.textContent='Adding\u2026';
        addVariant(id,q).then(function(){ return fetchCart(); }).then(function(){
          addBtn.textContent='Added \u2713'; openDrawer(); setTimeout(function(){ addBtn.textContent=t; },1200);
        }).catch(function(){ addBtn.textContent='Sold out'; setTimeout(function(){ addBtn.textContent=t; },1400); });
      });
    }
    // pdp thumbs
    document.querySelectorAll('.pdp__thumbs button').forEach(function(t){
      t.addEventListener('click', function(){
        document.querySelectorAll('.pdp__thumbs button').forEach(function(x){x.classList.remove('sel');});
        t.classList.add('sel');
        var main = document.querySelector('.pdp__main img'); if(main) main.src = t.dataset.full;
      });
    });
  }

  /* ---------- collection sort auto-submit ---------- */
  var sortSel = document.getElementById('SortBy');
  if(sortSel){ sortSel.addEventListener('change', function(){
    var u = new URL(window.location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page');
    window.location.href = u.toString();
  }); }

  /* ---------- countdown ---------- */
  function tick(){
    var H=document.querySelector('[data-h]'); if(!H) return;
    var now=new Date(), end=new Date(now); end.setHours(24,0,0,0);
    var diff=Math.max(0,(end-now)/1000);
    var h=Math.floor(diff/3600),m=Math.floor((diff%3600)/60),s=Math.floor(diff%60);
    var p=function(n){return (n<10?'0':'')+n;};
    H.textContent=p(h); document.querySelector('[data-m]').textContent=p(m); document.querySelector('[data-s]').textContent=p(s);
  }
  tick(); setInterval(tick,1000);

  /* ---------- init cart on load ---------- */
  fetchCart();
})();
